class ServerSideAdapter {
  static get() {}

  static set() {}
}

export { ServerSideAdapter };
